// Single source of truth for survey question types.
// Imported by the creator (survey-questionnaire-form, questions-form), the
// read-only editor view (question-component) and the shared runner (survey-runner).
// Add a new question type here once and every surface picks it up.

export const QUESTION_TYPES = [
    { value: 'comment', label: 'Comment', hasOptions: false },
    { value: 'scale5', label: 'Scale 1-5', hasOptions: false },
    { value: 'scale10', label: 'Scale 1-10', hasOptions: false },
    { value: 'rating', label: 'Rating', hasOptions: false, hasStars: true },
    { value: 'customOptions', label: 'Custom Options', hasOptions: true },
    { value: 'hybrid-customOptions', label: 'Custom Options&Other', hasOptions: true },
    { value: 'checkbox', label: 'Multiple Choice', hasOptions: true },
    { value: 'hybrid-checkbox', label: 'Multiple Choice&Comment', hasOptions: true },
    { value: 'matrix-scale5', label: 'Matrix (Scale 1-5)', hasOptions: false, hasItems: true },
];

const findType = (type) => QUESTION_TYPES.find((t) => t.value === type);

// Does this type require the author to supply answer options?
export const typeNeedsOptions = (type) => !!findType(type)?.hasOptions;

// Human readable label for a type value.
export const typeLabel = (type) => findType(type)?.label ?? type;

// Runner-side validation: has the current question been answered well enough to advance?
// Keeps the matrix / optional rules in one place instead of inside each runner.
export const isQuestionAnswered = (question, answer) => {
    if (!question) return true;
    if (question.optional === true) return true;

    if (question.type === 'matrix-scale5') {
        const itemsCount = question.items?.length || 0;
        const answeredCount = answer ? Object.keys(answer).length : 0;
        return answeredCount >= itemsCount;
    }

    return answer !== undefined && answer !== null && answer !== '';
};
